export const shouldSkipOffersQuery = false;
